class MissingProductDataModalController extends AbstractController
	@register()
	@inject 'product'

	initialize: ->
		@variantNames = []

		if @product.product_variants?
			for variant in @product.product_variants
				if _.isEmpty(variant.product_data)
					@variantNames.push(variant.product_variant_name)
